/**
 * Detects when the running JS bundle is older than the server build and prompts reload.
 * Fixes stale PWA / mobile browser caches after DigitalOcean deploys.
 */
import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config/api';

const CLIENT_SHA = (process.env.REACT_APP_BUILD_SHA || 'unknown').trim().slice(0, 7);

export function BuildFreshnessBanner() {
  const [stale, setStale] = useState(false);
  const [serverSha, setServerSha] = useState('');

  useEffect(() => {
    if (CLIENT_SHA === 'unknown') return;
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/health`, { cache: 'no-store' });
        if (!res.ok) return;
        const data = await res.json();
        const live = String(data.gitSha || 'unknown').trim().slice(0, 7);
        if (cancelled || live === 'unknown' || live === CLIENT_SHA) return;
        setServerSha(live);
        setStale(true);
      } catch {
        /* offline or auth not required path failed — ignore */
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!stale) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[100] px-2 py-1.5 bg-indigo-700 text-white text-[10px] flex items-center justify-between gap-2 shadow-lg"
      data-testid="build-freshness-banner"
    >
      <span>
        New version available ({serverSha || 'updated'}). You are on {CLIENT_SHA}.
      </span>
      <button
        type="button"
        className="shrink-0 px-2 py-0.5 rounded bg-white text-indigo-800 font-bold text-[10px]"
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  );
}
